module.exports = __webpack_public_path__ + "static/media/android1.6c5c4e54.jpg";